/**
 * A basic horizontal line with specified color and width.
 *
 * @component
 * @param {string} color - The color of the line.
 * @param {string} width - The width of the line.
 * @example
 * return (
 *  <ColoredLine color="blue" width="80%" />
 * )
 */
const ColoredLine = ({ color, width }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: "1px",
      width: width,
      marginTop: "20px",
      marginBottom: "20px",
      marginRight: "auto",
      marginLeft: "auto",
    }}
  />
);

export default ColoredLine;
